export default __webpack_public_path__ + "static/media/nave-reuveni.1b946459.png";